import React from "react"

import Index from "../components/pages/localization.js"

const IndexPage = () => (
  <Index lang="pl" />
)

export default IndexPage